import { AddWalletBalanceProps, DonationWallet } from '../workplaceGiving/workplaceGivingService.types'

import { PBPResponse } from '@percent/partner-dashboard/services/types/pbpResponses.types'
import {
  WalletBalanceServiceCapabilities,
  BulkWalletBalanceSummary,
  FundingSourcesResponse,
  GetAllocationsParams,
  GetAllocationsResponse,
  RemoveWalletBalanceProps
} from './walletBalanceService.types'

export const walletBalanceService = ({ percentClient }: WalletBalanceServiceCapabilities) => ({
  getAllocations: ({ accountId, includeExpired, includeUsed, sortBy, sortDirection }: GetAllocationsParams) => {
    const params: Record<string, string | boolean> = {}

    if (includeExpired !== undefined) {
      params.includeExpired = includeExpired
    }

    if (includeUsed !== undefined) {
      params.includeUsed = includeUsed
    }

    if (sortBy !== undefined) {
      params.sortBy = sortBy
    }

    if (sortDirection !== undefined) {
      params.sortDirection = sortDirection
    }

    return percentClient.get<PBPResponse<GetAllocationsResponse>>(
      `v1/accounts/${accountId}/donation-wallet/allocations`,
      { params }
    )
  },
  addWalletBalance: ({ amount, accountId, fundingSourceId, expiresAt }: AddWalletBalanceProps) => {
    const requestBody = {
      amount,
      ...(fundingSourceId && { fundingSourceId }),
      ...(expiresAt && { expiresAt })
    }

    return percentClient.post<PBPResponse<DonationWallet>>(`v1/accounts/${accountId}/donation-wallet/add`, requestBody)
  },
  removeWalletBalance: ({ amount, accountId, fundingSourceId }: RemoveWalletBalanceProps) => {
    const requestBody = {
      amount,
      ...(fundingSourceId && { fundingSourceId })
    }

    return percentClient.post<PBPResponse<DonationWallet>>(
      `v1/accounts/${accountId}/donation-wallet/remove`,
      requestBody
    )
  },
  addBatchWalletBalance: async (file: File, dryRun?: boolean) => {
    return percentClient.post<PBPResponse<BulkWalletBalanceSummary>>(`v1/donation-wallets/add-batch`, file, {
      ...(dryRun && { params: { dryRun: true } }),
      headers: {
        'Content-Type': 'text/csv'
      }
    })
  },
  getFundingSources: () => {
    return percentClient.get<PBPResponse<FundingSourcesResponse>>('v1/donation-wallets/funding-sources')
  }
})
